import { State } from '..';

export const getState = (state: State) => state.productions;
export const getEntities = (state: State) => state.productions.entities;
export const getIds = (state: State) => state.productions.ids;
export const getSelectedIds = (state: State) => state.productions.selectedIds;
